import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

export function useAdvisors() {
  const [advisors, setAdvisors] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchAdvisors()
  }, [])

  const fetchAdvisors = async () => {
    try {
      setLoading(true)
      const { data, error: err } = await supabase
        .from('advisors')
        .select('*')
        .order('full_name', { ascending: true })
      if (err) throw err
      setAdvisors(data || [])
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const createAdvisor = async (advisorData) => {
    const payload = {
      full_name: advisorData.full_name,
      name: advisorData.full_name,
      email: advisorData.email,
      mobile: advisorData.mobile,
    }
    if (advisorData.active !== undefined) payload.active = advisorData.active
    if (advisorData.licence_type) payload.licence_type = advisorData.licence_type
    if (advisorData.licence_number) payload.licence_number = advisorData.licence_number
    if (advisorData.advisor_code) payload.advisor_code = advisorData.advisor_code

    const { data, error } = await supabase
      .from('advisors')
      .insert([payload])
      .select()
    if (error) throw error
    await fetchAdvisors()
    return data[0]
  }

  const updateAdvisor = async (id, advisorData) => {
    const payload = {
      full_name: advisorData.full_name,
      name: advisorData.full_name,
      email: advisorData.email,
      mobile: advisorData.mobile,
    }
    if (advisorData.active !== undefined) payload.active = advisorData.active
    if (advisorData.licence_type !== undefined) payload.licence_type = advisorData.licence_type
    if (advisorData.licence_number !== undefined) payload.licence_number = advisorData.licence_number
    if (advisorData.advisor_code !== undefined) payload.advisor_code = advisorData.advisor_code

    const { data, error } = await supabase
      .from('advisors')
      .update(payload)
      .eq('id', id)
      .select()
    if (error) throw error
    await fetchAdvisors()
    return data[0]
  }

  const toggleAdvisorActive = async (id, currentValue) => {
    setAdvisors(prev => prev.map(a => a.id === id ? { ...a, active: !currentValue } : a))
    const { error } = await supabase
      .from('advisors')
      .update({ active: !currentValue })
      .eq('id', id)
    if (error) {
      setAdvisors(prev => prev.map(a => a.id === id ? { ...a, active: currentValue } : a))
      console.error('toggleAdvisorActive error:', error)
    }
  }

  const deleteAdvisor = async (id) => {
    const { error } = await supabase.from('advisors').delete().eq('id', id)
    if (error) throw error
    await fetchAdvisors()
  }

  return { advisors, loading, error, createAdvisor, updateAdvisor, toggleAdvisorActive, deleteAdvisor, refetch: fetchAdvisors }
}
